import { Bug } from "lucide-react";

/**
 * Plávajúce tlačidlo na nahlásenie chyby.
 *
 * `data-html2canvas-ignore` zabezpečí, že sa samotné tlačidlo nedostane
 * do snímky obrazovky.
 */
function SupportFab({ onClick, hidden = false, busy = false }) {
  return (
    <button
      type="button"
      className={`support-widget__fab ${hidden ? "support-widget__fab--hidden" : ""}`}
      onClick={onClick}
      disabled={busy}
      aria-label="Nahlásiť chybu"
      title="Nahlásiť chybu"
      data-html2canvas-ignore="true"
    >
      <Bug size={20} aria-hidden="true" />
    </button>
  );
}

export default SupportFab;
